import React, { useState } from "react";
import { MapPin, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const cls = "w-full rounded-2xl border-2 border-[#19324A]/10 bg-white px-4 py-3 text-sm outline-none focus:border-[#A78BFA]";

export default function SuggestPlace() {
  const { user } = useAuth();
  const [f, setF] = useState({ name: (user?.name || "").split(" ")[0], email: user?.email || "", place_name: "", suburb: "", why: "", link: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/places/suggest", f);
      setDone(true);
      toast.success("Thanks! Chewie & Solo will sniff it out 🐾");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-16" data-testid="suggest-place">
      <div className="rounded-[2rem] bg-[#19324A] text-white p-6 sm:p-10 grid lg:grid-cols-2 gap-8 items-center soft-shadow">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-[#A78BFA] text-white text-[11px] font-bold uppercase tracking-[0.18em] px-3 py-1"><MapPin className="w-3.5 h-3.5" /> Favourite Places</span>
          <h2 className="font-display font-extrabold text-2xl sm:text-3xl mt-4 !text-white">Know a bulldog-friendly spot?</h2>
          <p className="text-white/75 text-sm sm:text-base mt-3">Cafés with water bowls, beaches with shade, groomers who understand wrinkles — tell us where your bulldog loves to go and Chewie &amp; Solo might feature it next.</p>
        </div>
        {done ? (
          <div className="rounded-3xl bg-white/10 p-6" data-testid="suggest-place-done">
            <p className="font-display font-bold text-lg">Suggestion received 🐾</p>
            <p className="text-white/75 text-sm mt-1">Thanks {f.name || "friend"}! If Chewie &amp; Solo visit, we'll let you know.</p>
            <button onClick={() => { setDone(false); setF((s) => ({ ...s, place_name: "", suburb: "", why: "", link: "" })); }} className="mt-4 text-sm font-bold text-[#FFD93D]" data-testid="suggest-place-another">Suggest another</button>
          </div>
        ) : (
          <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3" data-testid="suggest-place-form">
            <input required value={f.name} onChange={set("name")} placeholder="Your first name" className={cls} data-testid="suggest-name" />
            <input required type="email" value={f.email} onChange={set("email")} placeholder="Your email" className={cls} data-testid="suggest-email" />
            <input required value={f.place_name} onChange={set("place_name")} placeholder="Name of the place" className={cls} data-testid="suggest-place-name" />
            <input value={f.suburb} onChange={set("suburb")} placeholder="Suburb / town" className={cls} data-testid="suggest-suburb" />
            <input value={f.link} onChange={set("link")} placeholder="Website or Instagram (optional)" className={`${cls} sm:col-span-2`} data-testid="suggest-link" />
            <textarea required rows={3} value={f.why} onChange={set("why")} placeholder="Why do bulldogs love it?" className={`${cls} sm:col-span-2`} data-testid="suggest-why" />
            <button type="submit" disabled={busy} className="btn-pink sm:col-span-2 disabled:opacity-60" data-testid="suggest-submit"><Send className="w-4 h-4" /> {busy ? "Sending…" : "Suggest this place"}</button>
          </form>
        )}
      </div>
    </section>
  );
}
